import React from 'react'
import { Card, CardActionArea, CardMedia, CardContent, Typography, Box, Grid } from '@mui/material'
import { grey } from '@mui/material/colors'

function CardParticular({ data, changeSpecialiste }) {
    return (
        <Card key={data.id} sx={{ cursor:'pointer', margin: '10px', borderRadius: '20px', maxWidth: { md: 400, sm: 400, xs: 400 },':hover':{backgroundColor:grey[200]} }} onClick={() => {
            changeSpecialiste(data.id, data.nom_service)
        }} >
            <Grid container>
                <Grid item xs={4}>
                    <CardMedia
                        component="img"
                        height="150"
                        width={50}
                        image={data.image_service}
                        style={{ objectFit: 'contain',borderRadius:'45px', padding:2,marginLeft:'5px' }}
                        alt="green iguana"
                    />
                </Grid>
                <Grid item xs={8}>
                    <CardContent>
                        <Typography variant="h8" component="div" sx={{color: '#d82967',fontWeight:'bold'}}>
                            {data.nom_service}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {data.description_service}
                        </Typography>
                    </CardContent>
                </Grid>
            </Grid>
        </Card>
    )
}

export default CardParticular